import Avatar from 'react-avatar';
import {
  ColorBox,
  ColorPicker,
  ColorPickerItem,
  Form,
  FormButton,
  HiddenFileInput,
  Separator,
  Title,
  UploadBox,
  UploadLabel,
  Wrapper
} from '../style';
import { AiOutlineUpload, AiOutlineCheck } from 'react-icons/ai';
import { useState } from 'react';

const colors = [
  '#DF4141',
  '#517CFD',
  '#DF4141',
  '#41A5EE',
  '#058F92',
  '#185C37',
  '#000000',
  '#616161',
  '#5E5E5E',
  '#9CABD6',
  '#483334',
  '#22305A',
  '#AE4BD5',
  '#444444',
  '#DF4141',
  '#ED6C47',
  '#A8BDFE',
  '#A8BDFE'
];

const AvatarUpload = () => {
  const [avatarColor, setAvatarColor] = useState('#058F92');

  return (
    <Wrapper>
      <Title>Customize your avatar</Title>

      <UploadBox>
        <UploadLabel htmlFor="uploadAvatar">
          <AiOutlineUpload />
          <p>
            Drop an image or <span>browser</span>
          </p>
          <HiddenFileInput type="file" id="uploadAvatar" />
        </UploadLabel>
        <Separator>or</Separator>

        <Avatar color={avatarColor} name="Otabek Nosirov" round="100px" size="140px" />

        <ColorBox>
          <h3>Choose avatar color:</h3>
          <ColorPicker>
            {colors.map((color, c) =>
              color !== avatarColor ? (
                <ColorPickerItem key={c} color={color} onClick={() => setAvatarColor(color)} />
              ) : (
                <ColorPickerItem key={c} color={color} onClick={() => setAvatarColor(color)}>
                  <AiOutlineCheck />
                </ColorPickerItem>
              )
            )}
          </ColorPicker>
        </ColorBox>
      </UploadBox>

      <Form>
        <FormButton maxWidth={true}>Continue</FormButton>
      </Form>
    </Wrapper>
  );
};

export default AvatarUpload;
